module.exports = __webpack_public_path__ + "media/hyper/images/products/product-2-2970f82088b7eb99bcab319db8d44755.jpg";